import React, { useState } from 'react';

const ResetPassword = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setIsError(true);
            setMessage('Passwords do not match.');
            return;
        }
        setIsLoading(true);
        setMessage('');
        try {
            const res = await fetch(process.env.REACT_APP_API_URL + 'auth/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword })
            });
            const data = await res.json();
            if (res.ok) {
                setIsError(false);
                setMessage(data.message);
                setTimeout(() => window.location.href = '/login', 2000);
            } else {
                setIsError(true);
                setMessage(data.message);
            }
        } catch (err) {
            setIsError(true);
            setMessage('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!token) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <p className="text-danger">Invalid reset link. <a href="/forgot-password">Try again</a></p>
            </div>
        );
    }

    return (
        <div className="position-fixed top-0 start-0 w-100 vh-100" style={{ zIndex: 9999, background: "#ffffff" }}>
            <div className="container-fluid h-100">
                <div className="row h-100">
                    <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-white"
                        style={{ background: "linear-gradient(135deg,#1d3557,#457b9d)" }}>
                        <h1 className="fw-bold mb-3">HashedBit CMS</h1>
                        <p style={{ maxWidth: "360px", textAlign: "center" }}>Set your new password below.</p>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <div style={{ width: "420px" }}>
                            <h2 className="fw-bold mb-4">Set New Password</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold">New Password</label>
                                    <input
                                        type="password"
                                        className="form-control form-control-lg"
                                        placeholder="Enter new password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold">Confirm Password</label>
                                    <input
                                        type="password"
                                        className="form-control form-control-lg"
                                        placeholder="Confirm new password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary w-100 btn-lg shadow" disabled={isLoading}>
                                    {isLoading ? "Resetting..." : "Reset Password"}
                                </button>
                            </form>
                            {message && (
                                <div className={`alert mt-4 ${isError ? 'alert-danger' : 'alert-success'}`}>
                                    {message}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
